module.exports = __webpack_public_path__ + "media/location-service_de_ipad_air.d82d4896.mp4";